var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShipping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M.937 11.042h27.96v26.27H.937zm1.248 1.249v23.773H27.65V12.29z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M27.648 16.3c0-.346.28-.625.624-.625h10.491c.2 0 .387.095.505.257l7.676 10.543c.077.106.12.235.12.367v8.05a.63.63 0 0 1-.18.438l-1.766 1.792a.62.62 0 0 1-.444.186H28.272a.624.624 0 0 1-.624-.624zm1.249.623V36.06h15.515l1.403-1.424v-7.59l-7.37-10.123z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M10.681 40.422a3.37 3.37 0 1 0 0-6.74 3.37 3.37 0 0 0 0 6.74M37.777 40.335a3.37 3.37 0 1 0 0-6.74 3.37 3.37 0 0 0 0 6.74"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M37.776 34.219a2.746 2.746 0 1 0 0 5.49 2.746 2.746 0 0 0 0-5.49m-3.994 2.746a3.994 3.994 0 1 1 7.989 0 3.994 3.994 0 0 1-7.989 0M28.293 31.28H1.56V30.03h26.732z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M40.428 15.635H28.224v3.755h12.204z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M27.6 15.01h13.453v5.004H27.6zm1.249 1.25v2.506h10.955v-2.507z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M30.462 19.21h1.249v7.443h14.371V27.9h-15.62z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M10.682 40.393a3.37 3.37 0 1 0 0-6.74 3.37 3.37 0 0 0 0 6.74"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.682 34.277a2.746 2.746 0 1 0 0 5.491 2.746 2.746 0 0 0 0-5.49m-3.995 2.746a3.994 3.994 0 1 1 7.989 0 3.994 3.994 0 0 1-7.988 0",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10.553 19.49c-.327-.193-.006-.484.297-.484.35.035.677.18.93.41 0 0-.843.304-1.227.075m-4.527 4.09c-1.127.29-.829-2.095.603-4.002a8.8 8.8 0 0 1 2.6-2.526c-.247 2.837-2.003 6.217-3.204 6.527m7.022-7.705a3.8 3.8 0 0 0-2.66.162 3.44 3.44 0 0 0-.125-1.587l-1.06.284c.094.6.117 1.208.07 1.813-2.373 1.316-4.18 3.374-5.104 5.816-.556 1.876.994 2.514 2.299 1.59 3.22-2.28 3.874-7.468 3.874-7.468a2.37 2.37 0 0 1 2.197.244c1.14.949-.34 2.405-.34 2.405a1.76 1.76 0 0 0-1.103-.494c-1.156-.1-1.739 1.237-.21 1.38.406.007.809-.058 1.188-.191.256.453.178 2.575-1.303 3.201-1.33.562-1.825-.226-1.825-.226-.272.28-.499.596-.674.938.258.313.617.538 1.023.643s.836.082 1.228-.064c.5-.176.951-.457 1.319-.822.367-.365.64-.804.8-1.284a2.96 2.96 0 0 0-.056-2.59c2.022-1.365 1.733-3.222.46-3.75"
})));
export { SvgShipping as ReactComponent };
export default "/_next/static/images/shipping.svg";